/** Axios interceptor returns `response.data`; some callers still expect `{ data: … }`. */
export function unwrapApiBody(res) {
  if (res == null || typeof res !== 'object') return res;
  if (
    'success' in res ||
    'until_date' in res ||
    'untilDate' in res ||
    'days' in res ||
    'message' in res
  ) {
    return res;
  }
  if (res.data != null && typeof res.data === 'object') return res.data;
  return res;
}

/** Normalize API date fields to YYYY-MM-DD for `<input type="date">`. */
export function pickIsoDate(v) {
  if (v == null || v === '') return null;
  if (v instanceof Date && !Number.isNaN(v.getTime())) {
    return v.toISOString().slice(0, 10);
  }
  const s = String(v).trim();
  const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
  return m ? m[1] : null;
}

export function apiErrorMessage(err, fallback = 'Request failed') {
  const body = unwrapApiBody(err?.response?.data);
  return body?.message || err?.message || fallback;
}
